import { SubAPI } from "./SubAPI";
export class ProjectFiles extends SubAPI {
    list(props) { return this.fetcher.get("/api/project-files", props); }
    upload(props) { return this.fetcher.postFormData("/api/project-file/upload", { file: props.file, meta: JSON.stringify({ project: props.project, kind: props.kind, directory: props.directory }) }); }
    upsertDir(input) { return this.fetcher.post("/api/project-file/directory", input); }
    upsert(props) { return this.fetcher.post("/api/project-file", props); }
    downloadLink(id, kind) { return "/api/project-file/download?id=" + id + "&kind=" + (kind || "attachment"); }
}
